import { env } from './env';

/**
 * The OneSchema template an importer opens for `templateKey`: on a deploy preview whose branch
 * changed that template, the preview's own copy of it, published under its own key; everywhere
 * else, the template itself.
 */
export const resolveOneSchemaTemplateKey = (
  templateKey: string,
  previewTemplates: Record<string, string> = env.REACT_APP_ONE_SCHEMA_PREVIEW_TEMPLATES,
): string => previewTemplates[templateKey] ?? templateKey;
